import React from 'react';
import { FilterCheckbox, MultiSelect } from './registerFilters';

export const GRAINS = [['month', 'Month'], ['quarter', 'Quarter'], ['year', 'Year']];
export const WINDOWS = [12, 18, 24];

/** The filter bar the Utilization and Capacity Planner tabs share: teams, scenario, grouping, pipeline, timeline. */
export default function PlannerToolbar({
  teamOptions, teamIds, onTeams, scenarioId, scenarioLabel, saved, onScenario, grain, onGrain,
  includePipeline, onPipeline, windowMonths, onWindow, onEarlier, onToday, onLater, children,
}) {
  return (
    <div className="up-filters">
      <MultiSelect label="Teams" options={teamOptions} selected={teamIds} onChange={onTeams} allLabel="All teams" minWidth={170} showSelectAll />
      <div>
        <label className="form-label">Scenario</label>
        <select className="form-select" value={scenarioId} onChange={(e) => onScenario(e.target.value)}>
          <option value="">{scenarioLabel}</option>
          {saved.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
        </select>
      </div>
      {children}
      <div className="up-grain" role="group" aria-label="Time grouping">
        {GRAINS.map(([k, label]) => <button key={k} className={grain === k ? 'btn btn-primary' : 'btn btn-outline'} onClick={() => onGrain(k)}>{label}</button>)}
      </div>
      <FilterCheckbox label="Include pipeline" checked={includePipeline} onChange={onPipeline} />
      <div>
        <label className="form-label">Timeline</label>
        <select className="form-select" value={windowMonths} onChange={(e) => onWindow(Number(e.target.value))}>
          {WINDOWS.map((w) => <option key={w} value={w}>{w} months</option>)}
        </select>
      </div>
      <div className="up-grain">
        <button className="btn btn-outline" aria-label="Earlier" onClick={onEarlier}>◀</button>
        <button className="btn btn-outline" onClick={onToday}>Today</button>
        <button className="btn btn-outline" aria-label="Later" onClick={onLater}>▶</button>
      </div>
    </div>
  );
}
